import { redux } from 'Core/redux';
import { STORE_KEY, INITIAL_STATE } from './slice';

export const selectForklift = state => {
  const appState = state || redux.store.getState();
  return appState?.[STORE_KEY] || INITIAL_STATE;
};

export const selectForkliftData = state => selectForklift(state).data;
export const selectForkliftLoading = state => selectForklift(state).loading;
export const selectForkliftError = state => selectForklift(state).error;
export const selectForkliftMaintenanceRecordsData = state => selectForklift(state).maintenanceRecordsData;
export const selectMaintenanceRecordData = state => selectForklift(state).maintenanceRecordData;
export const selectForkliftMaintenanceData = state => selectForklift(state).maintenanceData;
export const selectCellHistoryData = state => selectForklift(state).cellHistoryData;
export const selectTileView = state => selectForklift(state).tileView;
